import { Slide } from "@jelly/lesson";

import { task as task01 } from "../../../../../task/course-04/lesson-27/task-01";

const task: Slide = {
  title: "Click on the properties that “delay and sum” beamforming has.",
  description: "Select the correct answer(s).",
  layout: {
    type: "simple",
    options: {
      components: {
        variant: "__task__",
        data: {
          id: task01.id,
        },
      },
    },
  },
};

export default task;
